import styles from "./Terms.module.scss";
import { useEffect } from "react";

function Terms() {
  useEffect(() => {
    document.title = "Terms & Conditions and Privacy Policy | Amenigies";
  }, []);
  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Terms and Conditions</h1>
      </div>

      <div className={styles.centerSubHeadingContainer}>
        <p className={styles.boldSubHeading}>Amenigies Mobile Application</p>
        <p className={styles.subHeading}>Last Updated: 12/23/2025</p>
        <p></p>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>1. Introduction</h2>
        <div className={styles.descriptionContainer}>
          <p className={styles.description}>
            Welcome to Amenigies. Amenigies LLC is a US-based company that
            provides management and digital access to building amenities through
            its mobile and web applications.
          </p>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>2. Eligibility</h2>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              You must be a tenant of a participating building or an approved
              member to use the App.
            </li>
            <li className={styles.listItem}>
              You must provide accurate and complete information during
              registration.
            </li>

            <li className={styles.listItem}>
              Access to amenities is subject to active lease and membership
              status.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>3. Membership & Subscription</h2>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              Amenigies offers monthly subscription-based amenity packages.
            </li>
            <li className={styles.listItem}>
              Subscriptions are billed monthly only.
            </li>
            <li className={styles.listItem}>
              No yearly or bi-yearly subscription options are available.
            </li>
            <li className={styles.listItem}>
              Subscription fees are charged automatically each month using the
              selected payment method.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>4. Cancellation & Refund Policy</h2>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              Tenants may cancel their subscription at any time.
            </li>
            <li className={styles.listItem}>Upon cancellation:</li>
            <ul className={styles.nestedList}>
              <li className={styles.listItem}>
                No further charges will be applied.
              </li>
              <li className={styles.listItem}>
                Previously paid amounts are non-refundable.
              </li>
              <li className={styles.listItem}>
                Access to amenities remains available until the next billing
                date.
              </li>
            </ul>
            <li className={styles.listItem}>
              If a tenant’s lease ends or is revoked, the membership will
              automatically end, regardless of subscription status.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>5. Amenities Access</h2>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              Tenants may access amenities only according to their selected
              package.
            </li>
            <li className={styles.listItem}>
              Some amenities require booking for a specific date and time.
            </li>
            <li className={styles.listItem}>
              Bookable amenities may be free or paid.
            </li>
            <li className={styles.listItem}>
              Unauthorized access or misuse may result in account suspension or
              termination.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>6. Payments</h2>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              All payments are processed securely via third-party payment
              providers.
            </li>
            <li className={styles.listItem}>
              Amenigies does not store full card details.
            </li>
            <li className={styles.listItem}>
              You are responsible for ensuring your payment information remains
              up to date.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>7. Lease Dependency</h2>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              Amenigies access is directly linked to your apartment lease status
              unless otherwise approved.
            </li>
            <li className={styles.listItem}>
              If your lease expires or is revoked, your membership and amenity
              access will be terminated automatically.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>8. Account Suspension & Termination</h2>
        <p className={styles.subjectDescription}>
          Amenigies reserves the right to suspend or terminate accounts if:
        </p>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              False or misleading information is provided.
            </li>
            <li className={styles.listItem}>The App is misused.</li>
            <li className={styles.listItem}>
              Security or policy violations occur.
            </li>
            <li className={styles.listItem}>
              Building participation setup is modified or revoked.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>9. Limitation of Liability</h2>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              Temporary unavailability of amenities.
            </li>
            <li className={styles.listItem}>
              Access issues caused by building systems, locks, or third-party
              services.
            </li>
            <li className={styles.listItem}>
              Any indirect or consequential damages.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>10. Changes to Terms</h2>
        <p className={styles.subjectDescription}>
          Amenigies may update these Terms & Conditions at any time. Continued
          use of the App indicates acceptance of updated terms.
        </p>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>11. Contact Information</h2>
        <div className={styles.contactContainer}>
          <p className={styles.contact}>
            Email:{" "}
            <a className={styles.link} href="mailto:info@amenigies.com">
              info@amenigies.com
            </a>
          </p>
        </div>
      </div>

      <div className={styles.dividerContainer} />

      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Privacy Policy</h1>
      </div>

      <div className={styles.centerSubHeadingContainer}>
        <p className={styles.boldSubHeading}>Amenigies Mobile Application</p>
        <p className={styles.subHeading}>Last Updated: 12/23/2025</p>
        <p></p>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>1. Introduction</h2>
        <div className={styles.descriptionContainer}>
          <p className={styles.description}>
            Amenigies respects your privacy and is committed to protecting your
            personal information. This Privacy Policy explains how we collect,
            use, and protect your data when you use our App.
          </p>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>2. Information We Collect</h2>
        <div className={styles.descriptionContainer}>
          <h3 className={styles.subject}>Personal Information</h3>
        </div>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>Name</li>
            <li className={styles.listItem}>Email address</li>
            <li className={styles.listItem}>Phone number</li>
            <li className={styles.listItem}>Apartment/unit details</li>
            <li className={styles.listItem}>Lease-related information</li>
            <li className={styles.listItem}>
              Copy of member's ID (where applicable)
            </li>
          </ul>
        </div>
        <div className={styles.descriptionContainer}>
          <h3 className={styles.subject}>Payment Information</h3>
        </div>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              Payment processing is handled by third-party providers.
            </li>
            <li className={styles.listItem}>
              Amenigies does not store credit or debit card details.
            </li>
          </ul>
        </div>
        <div className={styles.descriptionContainer}>
          <h3 className={styles.subject}>Usage Data</h3>
        </div>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>App activity</li>
            <li className={styles.listItem}>
              Amenity access logs (including door logs)
            </li>
            <li className={styles.listItem}>Booking history</li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>3. How We Use Your Information</h2>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>Create and manage your account</li>
            <li className={styles.listItem}>
              Process subscriptions and bookings
            </li>
            <li className={styles.listItem}>Control access to amenities</li>
            <li className={styles.listItem}>
              Send billing and service notifications
            </li>
            <li className={styles.listItem}>
              Improve app performance and security
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>4. Data Sharing</h2>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              Building management (lease verification only)
            </li>
            <li className={styles.listItem}>
              Payment processors (payment handling only)
            </li>
            <li className={styles.listItem}>
              Service providers required to operate the App
            </li>
            <li className={styles.listItem}>
              Security personnel and providers to monitor amenity spaces
            </li>
          </ul>
        </div>
        <div className={styles.descriptionContainer}>
          <p className={styles.description}>
            We do not sell your personal data.
          </p>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>5. Data Security</h2>
        <div className={styles.descriptionContainer}>
          <p className={styles.description}>
            We implement reasonable technical and organizational measures to
            protect your data from unauthorized access, loss, or misuse.
          </p>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>6. Data Retention</h2>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              Data is retained while your account is active.
            </li>
            <li className={styles.listItem}>
              Some data may be retained for legal, billing, or audit purposes
              after account termination.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>7. Your Rights</h2>
        <div className={styles.listContainer}>
          <ul className={styles.list}>
            <li className={styles.listItem}>Access your data</li>
            <li className={styles.listItem}>Request corrections</li>
            <li className={styles.listItem}>
              Request deletion (subject to legal requirements)
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>8. Third-Party Services</h2>
        <div className={styles.descriptionContainer}>
          <p className={styles.description}>
            The App may integrate with third-party services (payment gateways,
            door access systems, building management software, CCTV systems).
            Amenigies is not responsible for their privacy practices.
          </p>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>9. Children's Privacy</h2>
        <div className={styles.descriptionContainer}>
          <p className={styles.description}>
            Amenigies is not intended for users under the age of 18.
          </p>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>10. Changes to This Policy</h2>
        <div className={styles.descriptionContainer}>
          <p className={styles.description}>
            We may update this Privacy Policy from time to time. Updates will be
            posted within the App.
          </p>
        </div>
      </div>

      <div className={styles.subjectContainer}>
        <h2 className={styles.subject}>11. Contact Us</h2>
        <div className={styles.contactContainer}>
          <p className={styles.contact}>
            Email:{" "}
            <a className={styles.link} href="mailto:info@amenigies.com">
              info@amenigies.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Terms;
